import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: '420px',
    height: '500px',
    overflow: 'hidden',
    borderRadius: '8px',
  },
  dialogHeader: {
    paddingLeft: 20,
    paddingRight: 13,
    ...theme.dialogs.header,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 60,
    minHeight: 60,
  },
  headerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTitle: {
    ...theme.dialogs.title,
    color: theme.palette.primary.dark,
    fontSize: '18px',
    fontFamily: 'Roboto',
    marginRight: '20px',
  },
  tableContainer: {
    height: '700px',
    overflowY: 'auto',
  },
  tableHeadCell: {
    fontSize: '16px',
    fontFamily: 'Roboto',
    color: theme.palette.primary.dark,
    padding: '0 15px !important',
    backgroundColor: '#fff',
    textTransform: 'none',
    height: '40px',
  },

  tableCell: {
    ...theme.tables.tableCell,
    fontSize: '15px',
    padding: '0 15px !important',
    height: '50px',
    border: 0,
    fontWeight: '500',
    borderBottom: '1px solid #E1E2EA !important',
  },

  loaderCell: {
    height: '400px',
    verticalAlign: 'middle',
  },

  iconBtnStyle: {
    width: 32,
    height: 32,
    marginLeft: 8,
  },
}));

export default useStyles;
